var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-window',{ref:"window",staticClass:"fwindow-width-4",attrs:{"title":_vm.title,"closing-disabled":_vm.txStatus === 'pending'}},[_vm._t("default",null,{"onTxStatus":_vm.onTransactionStatus})],2)}
var staticRenderFns = []

export { render, staticRenderFns }